import { render } from "./ProduccionPage.vue?vue&type=template&id=09fcbf03&scoped=true"
import script from "./ProduccionPage.vue?vue&type=script&lang=js"
export * from "./ProduccionPage.vue?vue&type=script&lang=js"

import "./ProduccionPage.vue?vue&type=style&index=0&id=09fcbf03&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09fcbf03"]])

export default __exports__